import React from 'react';
import { Draw as DrawIcon } from '@mui/icons-material';
import { Header } from '../components/Header/Header';
import './WelcomePage.scss';

export function WelcomePage() {
  return (
    <div className="welcome-page">
      <Header />
      <div className="welcome-page__content">
        <div className="welcome-page__icon">
          <DrawIcon sx={{ fontSize: 64, color: '#7db8e0' }} />
        </div>
        <h2 className="welcome-page__title">Patient Signing Portal</h2>
        <p className="welcome-page__message">
          Welcome to the ClinicTech Patient Signing Portal. To sign a document,
          please use the link provided by your healthcare provider via QR code
          or SMS.
        </p>
        <p className="welcome-page__note">
          If you haven't received a signing link, please contact your clinic
          or healthcare provider for assistance.
        </p>
      </div>
    </div>
  );
}

export default WelcomePage;
